<sha-connectivity-banner></sha-connectivity-banner> <router-outlet></router-outlet>
